module.exports = __webpack_public_path__ + "static/media/web.70923931.svg";